var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.594,
    height: 112.572,
    viewBox: "0 0 84.594 112.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-1447.703 -1062.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 84.594,
    height: 108.477,
    rx: 9,
    transform: "translate(1447.703 1066.502)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f02eff609b488bcc49ee935191fa22cc",
    transform: "translate(1378.443 1054.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M147.087,22.9h-.027V69.371c0,30.371-24.823,54.99-55.434,54.99H69.26v.027a6.741,6.741,0,0,0,6.768,6.713h71.059a6.741,6.741,0,0,0,6.768-6.713V29.613A6.741,6.741,0,0,0,147.087,22.9Z",
    transform: "translate(0 -11.029)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M99.14,146.8V53.893a1.133,1.133,0,0,1,1.133-1.133h68.8a1.133,1.133,0,0,1,1.133,1.133v76.751l-17.282,17.284H100.268A1.133,1.133,0,0,1,99.14,146.8Z",
    transform: "translate(-23.112 -35.008)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M244.938,229.74A55.447,55.447,0,0,1,195.8,284.821h31.883l17.282-17.284Z",
    transform: "translate(-97.878 -171.902)",
    fill: "#f0e6c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M188.013,60.542h-41.93A5.087,5.087,0,0,1,141,55.459v-5.1a5.09,5.09,0,0,1,5.083-5.083h41.93a5.09,5.09,0,0,1,5.083,5.083v5.1A5.087,5.087,0,0,1,188.013,60.542Zm-41.93-11.864a1.687,1.687,0,0,0-1.685,1.685v5.1a1.687,1.687,0,0,0,1.685,1.685h41.93a1.687,1.687,0,0,0,1.685-1.685v-5.1a1.687,1.687,0,0,0-1.685-1.685Z",
    transform: "translate(-55.491 -29.223)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M147.882,423.818H138.2a1.7,1.7,0,1,1,0-3.4h9.692a1.7,1.7,0,1,1,0,3.4Z",
    transform: "translate(-52.01 -319.392)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M222.882,423.818H213.2a1.7,1.7,0,1,1,0-3.4h9.692a1.7,1.7,0,0,1,0,3.4Z",
    transform: "translate(-110.022 -319.392)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M297.839,423.818H288.2a1.7,1.7,0,0,1,0-3.4h9.649a1.7,1.7,0,1,1,0,3.4Z",
    transform: "translate(-168.034 -319.392)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M3.844,0H38.084a3.844,3.844,0,0,1,3.844,3.844v6.236a3.844,3.844,0,0,1-3.844,3.844H3.844A3.844,3.844,0,0,1,0,10.079V3.844A3.844,3.844,0,0,1,3.844,0Z",
    transform: "translate(90.592 7.5)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M201.625,7.5h-2.979a3.624,3.624,0,0,1,.029.453A10.079,10.079,0,0,1,188.6,18.032H163.57a3.851,3.851,0,0,0,3.814,3.4h34.243a3.851,3.851,0,0,0,3.851-3.851V11.344A3.851,3.851,0,0,0,201.625,7.5Z",
    transform: "translate(-72.948)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M238.1,283.18a21.726,21.726,0,0,1-30.693,19.792l8.967-19.792Z",
    transform: "translate(-106.859 -213.238)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M234.441,283.18A21.744,21.744,0,0,1,208.3,301l-.89,1.968A21.726,21.726,0,0,0,238.1,283.18Z",
    transform: "translate(-106.859 -213.238)",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M172.665,219.405,163.7,239.2c-8.437-3.731-14.193-13.509-12.51-23.1a21.9,21.9,0,0,1,10.449-15.364Z",
    transform: "translate(-63.146 -149.463)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M154.395,215.33a21.837,21.837,0,0,1,7.864-13.561l-.63-1.069a21.9,21.9,0,0,0-10.449,15.364c-1.683,9.6,4.077,19.38,12.51,23.1l.886-1.957C157.443,232.852,152.875,224.019,154.395,215.33Z",
    transform: "translate(-63.139 -149.44)",
    fill: "#2552d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M252.169,171.243H231.036L220.3,153.069a22.143,22.143,0,0,1,6.073-2.439C239.154,147.6,252.328,157.814,252.169,171.243Z",
    transform: "translate(-116.829 -110.295)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M223.014,154.024c11.679-2.77,23.683,5.52,25.536,17.214h3.658c.17-13.429-13-23.645-25.785-20.612a22.143,22.143,0,0,0-6.073,2.439l.868,1.47C221.815,154.335,222.427,154.158,223.014,154.024Z",
    transform: "translate(-116.868 -110.293)",
    fill: "#124822"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M336.56,413.894V403.378a6.768,6.768,0,0,1,6.768-6.768h10.514Z",
    transform: "translate(-206.756 -300.975)",
    fill: "#fef8e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.caa90a113ec8fb8a98bda845a4aa6f9d.svg";
export { ForwardRef as ReactComponent };